pageId = 'members-answer_accesses-edit'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  tower.initManageMembers($page.find('.form'), true)
